import React from "react";
import "./style.css";
import { Select } from "antd";
import Programs from "../vendorPrograms/index";

export default class Vendors extends React.Component {
  render() {
    return (
      <div>
        <Programs />
      </div>
    );
  }
}
